<template>
  <a-modal :visible="true" title="查看图片" @cancel="handleCancel" :footer="null" :width="800">
    <img v-for="(src, i) in pictures" :key="i" :src="src" style="width:100%; margin-bottom: 8px;" />
  </a-modal>
</template>

<script>
export default {
  props: ['src'],
  data () {
    return {
      pictures: []
    }
  },
  methods: {
    handleCancel (e) {
      this.$emit('clear-src')
    }
  },
  mounted () {
    this.pictures = this.src ? this.src.split(',') : []
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/PreviewImage.vue